import { encryptAES } from "../../services/CryptoService";
import { getAuthProps } from "../../lib/authenticationLibrary";

// const isEncryptionEnabled = process.env.REACT_APP_IsEncryption;

const isEncryptionEnabled = true;
export const transformRequest = (reqData, type = null) => {
  const authData = getAuthProps();
  const memberId = authData?.adminUserId;
  let payload = { ...reqData };
  if (type === "create") {
    payload.CreatedBy = 115;
    payload.CreatedAppId = memberId;
  }

  if (type === "update") {
    payload.UpdatedBy = 115;
    payload.UpdatedAppId = memberId;
  }
  const data = { data: isEncryptionEnabled ? encryptAES(payload, 1) : payload };
  return data;
}


export const encryptQueryString = (url) => {
  if (isEncryptionEnabled) {
    const urlParts = url.split("=");
    if (urlParts.length === 2) {
      const queryString = urlParts[1];
      const encryptedQueryString = encryptAES(queryString, 1); // Replace with your encryption logic
      return `${urlParts[0]}=${encryptedQueryString}`;
    }
  }
  // If the URL doesn't contain query parameters or is in an invalid format, return the original URL.
  return url;
}
